import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";
import { Contingencia } from "../../models/riesgo/Contingencia";

export const PlanContingencia = ({ generic, permss, toast, riesgo, id, catalogos, funcionalidades }) => {

    const omodel = new Contingencia();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl, stringToDate } = Generico();
    const defaultValues = generic.default(omodel.model);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [dialogContingencia, setDialogContingencia] = useState(false);
    const [titulo, setTitulo] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [lista, setLista] = useState(null);
    const [load, setLoad] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inCalendar } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        setLista(catalogos);
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.idp = id;
        matrizSrv.listado('matriz-riesgo-contingencia/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogContingencia(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.fecha_inicio = data.fecha_inicio.toISOString().split('T')[0];
        data.fecha_fin = data.fecha_fin.toISOString().split('T')[0];
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-contingencia/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogContingencia(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo-contingencia/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogContingencia(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${id}`, 'matriz-riesgo-contingencia/consulta').then(res => {
            const _riesgo = res.data;
            if (_riesgo.fecha_inicio) _riesgo.fecha_inicio = stringToDate(_riesgo.fecha_inicio);
            if (_riesgo.fecha_fin) _riesgo.fecha_fin = stringToDate(_riesgo.fecha_fin);
            reset(generic.renewValues(_riesgo, omodel.model));
            setDialogContingencia(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${id}`, 'matriz-riesgo-contingencia/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} />}
                    <span className="font-bold">PLAN DE CONTINGENCIA (MITIGADOR DE CONSECUENCIAS)</span>
                </div>
            </div>
        );
    }

    const seleccion = (info, listado) => {
        const _lista = lista;
        _lista[tipo] = listado;
        setLista(_lista);
    }

    const criterios = (opc, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setTipo(opc);
        setDialogCriterio(true);
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogContingencia} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogContingencia(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('detalle', {}, 12)}
                        {inDrop('responsable', lista?.MTR_RIESGO_ACTOR_INTERNO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar"
                                onClick={() => criterios('MTR_RIESGO_ACTOR_INTERNO', 'responsable')} />
                        </div>

                        {inCalendar('fecha_inicio', {}, 12)}
                        {inCalendar('fecha_fin', { maxDate: null }, 12)}
                    </div>
                    {generic.buttonsForms(setDialogContingencia, load)}
                </form>
            </Dialog>

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
            }}
                style={{ maxWidth: '500px' }}>
                <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={false} listar="solo" funcionalidades={funcionalidades} />
            </Dialog>
        </>
    )
}

